<template>
    <div @click="$emit('select', component)" class="grid gap-6"
         :class="`grid-cols-${component.attributes.columns}`">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "Column",
    props: {
        component: {
            type: Object,
            required: true,
        }
    }
}
</script>

<style scoped>

</style>
